import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button, Typography as MuiTypography } from '@material-ui/core';
import { SearchInput } from 'components';
import Grid from '@material-ui/core/Grid';
import ToggleButton from '@material-ui/lab/ToggleButton';


const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    display: 'flex',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)

  },
  search: {
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  componentsSearch: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const PacoteToolbar = props => {
  const { className, filterPacotes, ...rest } = props;
  const [filterValue, setFilterValue] = useState('');
  const [alignment, setAlignment] = React.useState('1');


  const classes = useStyles();

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const children = [
    <ToggleButton key={1} value="1">
      <MuiTypography variant="h6">Nome/CPF/CR</MuiTypography>
    </ToggleButton>,
    <ToggleButton key={2} value="2">
      <MuiTypography variant="h6">Vencimento CR</MuiTypography>
    </ToggleButton>
  ];

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >

      <div className={classes.componentsSearch}>
        <Grid
          container
          spacing={2}
        >

          <Grid
            item
            md={10}
            xs={12}
          >
            <SearchInput
              className={classes.searchInput}
              placeholder="Pesquise pela descrição do pacote"
              onChange={e => setFilterValue(e.target.value)}
              onKeyPress={(ev) => {
                if (ev.key === 'Enter') {
                  // Do code here
                  ev.preventDefault();
                  filterPacotes(filterValue);
                }
              }}
            />
          </Grid>
          <Grid
            item
            md={2}
            xs={12}
          >
            <Button
              style={{width: '100%'}}
              color="primary"
              variant="contained"
              onClick={e => filterPacotes(filterValue)}
            >
              Pesquisar
            </Button>
          </Grid>

        </Grid>
      </div>
    </div>
  );
};

PacoteToolbar.propTypes = {
  className: PropTypes.string
};

export default PacoteToolbar;
